import { render } from "./CampaignSkeleton.vue?vue&type=template&id=6feb7ffc&scoped=true"
import script from "./CampaignSkeleton.vue?vue&type=script&lang=js"
export * from "./CampaignSkeleton.vue?vue&type=script&lang=js"

import "./CampaignSkeleton.vue?vue&type=style&index=0&id=6feb7ffc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6feb7ffc"]])

export default __exports__